import React, { useState, createContext, useMemo } from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';

// components
import CardArt from './CardArt';
import CardTitle from './CardTitle';
import AnnualFee from './AnnualFee';
import Offer from './Offer';
import Highlights from './Highlights';
import Quickview from './Quickview';
import Tncs from './Tncs';
import ApplyNowCta from './ApplyNowCta';
import LearnMoreCta from './LearnMoreCta';
import UpgradeCta from './UpgradeCta';
import AdditionalUpgradeText from './AdditionalUpgradeText';
import AddEmployeeCta from './AddAnEmployeeCta';
import ColorPicker, { parent } from 'src/universal/components/ColorPicker';
import CheckboxCompareButton from 'src/universal/components/CheckboxCompareButton';
import Ribbon, { POSITIONS } from './Ribbon';
import YourCardBadge from 'src/universal/components/YourCardBadge';
import AmazonDisclaimer from '../../AmazonDisclaimer';

import { makeGetCardTitle, makeGetIsTier1Offer } from '../redux';

import styles from '../__styles__/index.scss?modules';

export const QuickViewContext = createContext(null);

const Tile = ({ shortName, cardTitle, isTier1Offer }) => {
  const [isQuickViewOpen, setIsQuickViewOpen] = useState(false);
  const contextValue = useMemo(() => ({ isQuickViewOpen, setIsQuickViewOpen }), [
    isQuickViewOpen,
    setIsQuickViewOpen
  ]);

  return (
    <QuickViewContext.Provider value={contextValue}>
      <div
        className={isTier1Offer ? styles.tier1TileContainer : styles.tileContainer}
      >
        <div className={styles.topRow}>
          <Ribbon position={POSITIONS.TILE_RIBBON} shortName={shortName} />
          <div
            className={clsx(styles.leftCol, {
              [styles.tier1Tile]: isTier1Offer
            })}
          >
            <CardArt shortName={shortName} />
            <ColorPicker shortName={shortName} parentType={parent.VAC_TILE} />
            <UpgradeCta shortName={shortName} />
            <ApplyNowCta shortName={shortName} />
            <AdditionalUpgradeText shortName={shortName} />
            <LearnMoreCta shortName={shortName} />
            <CheckboxCompareButton cardTitle={cardTitle} shortName={shortName} />
            <AddEmployeeCta shortName={shortName} />
            <Tncs shortName={shortName} />
          </div>
          <div
            className={clsx(styles.middleCol, {
              [styles.tier1Tile]: isTier1Offer
            })}
          >
            <CardTitle shortName={shortName} />
            <YourCardBadge shortName={shortName} />
            <AnnualFee shortName={shortName} />
            <Offer shortName={shortName} />
            <AmazonDisclaimer shortName={shortName} />
          </div>
          <div
            className={clsx(styles.rightCol, {
              [styles.tier1Tile]: isTier1Offer
            })}
          >
            <Highlights shortName={shortName} />
          </div>
        </div>
        <Quickview shortName={shortName} />
      </div>
    </QuickViewContext.Provider>
  );
};

const mapStateToProps = () => {
  const getCardTitle = makeGetCardTitle();
  const getIsTier1Offer = makeGetIsTier1Offer();

  return (state, { shortName }) => {
    return {
      cardTitle: getCardTitle(state, shortName),
      isTier1Offer: getIsTier1Offer(state, shortName)
    };
  };
};

export default connect(mapStateToProps)(Tile);
